import { connect } from 'react-redux';
import { formValueSelector } from 'redux-form';
import { bindActionCreators } from 'redux';
import Form from '../../components/forms/RequestFormAdding';
import { newRequestInternal, withRedirect } from '../../CroActions';
import { breadcrumbs } from '../../../../actions/appActions';
import { noop } from 'lodash';

const selector = formValueSelector('requestForm');

const mapStateToProps = (state, { params }) => ({
  loginData: (selector(state, 'person.firstName', 'person.lastName', 'person.id') || {}).person,
  breadcrumbsItems: [{ label: 'Žádosti o nahlédnutí na neveřejné oznámení' }, { label: 'Nová žádost o nahlédnutí na neveřejné oznámení' }],
  aifo: selector(state, 'person.aifo'),
  legalPerson: selector(state, 'legalPerson'),
  officials: selector(state, 'officials') || [],
  attachments: selector(state, 'attachments') || [],
  adminFiles: selector(state, 'adminFiles') || [],
  state: selector(state, 'state') || '',
  isNew: true,
  rejectText: selector(state, 'rejectText'),
  text: selector(state, 'text'),
});

const onSubmit = url => withRedirect(newRequestInternal, `${url}/zadosti`);

const mapDispatchToProps = (dispatch, props) => ({
  ...bindActionCreators({ onSubmit: onSubmit(props.auth.startUrl), breadcrumbs }, dispatch),
  accept: noop,
  reject: noop,
  dispatch,
})

export default connect(mapStateToProps, mapDispatchToProps)(Form);
